/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DateAndTimeDetails {
    getFixupPrototypeFunction() { return DateAndTimeDetails.fixupPrototype; }

    static newInstance(model: Partial<DateAndTimeDetails>): DateAndTimeDetails {
        let obj = Object.assign(new DateAndTimeDetails(), model);
        DateAndTimeDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DateAndTimeDetails>): DateAndTimeDetails {
        if (!model) return null;
        return DateAndTimeDetails.newInstance(<DateAndTimeDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DateAndTimeDetails) {
        if (!obj) return;

        models.DateAndTimeDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DateAndTimeDetails): boolean {
        Object.setPrototypeOf(obj, DateAndTimeDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.time) {
            models.TimeDetails.fixupPrototype(this.time);
        }
        if (this.dayofmonth) {
            models.DayDetails.fixupPrototype(this.dayofmonth);
        }
        if (this.weekday) {
            models.DayDetails.fixupPrototype(this.weekday);
        }
    }

    /**
     * Month when the Template/Policy is scheduled to run. Allowed values: 01-12
     */
    month: string;

    /**
     * Time when the Template/Policy is scheduled to run.
     */
    time: models.TimeDetails;

    /**
     * At which day of that month the Template/Policy is scheduled to run.Note - weekday and dayofmonth are alternate.Allowed values: 01-31
     */
    dayofmonth: models.DayDetails;

    /**
     * At which day of that week the Template/Policy is scheduled to run.Note - weekday and dayofmonth are alternate.Allowed values: 01-07
     */
    weekday: models.DayDetails;

    /**
     * Year when the Template/Policy is scheduled to run. Example:'year':'2022'
     */
    year: string;

}
